export function extractExternalCode(data: any): string {
  return (
    data?.Production?.entities?.proposal?.views?.Production_all?.properties
      ?.LineID?.views?.PlanConfigManagement_all?.properties?.ExternalCode || ''
  );
}

export function extractProposalType(data: any): string {
  return (
    data?.Production?.entities?.proposal?.views?.Production_all?.properties
      ?.Type || ''
  );
}
